export interface Role {
  id?: number
  profileId: number
  name: string
}

export interface InsertRoleBulkRequest {
  roles: Role[]
}

export interface Permission {
  key: string
  name: string
  icon: string
  allowAccess?: boolean
  items?: Permission[] | null
}

export const MENU_PERMISSION_SECTIONS: Permission[] = [
  {
    key: 'dashboard',
    name: 'Dashboard',
    icon: 'Home.svg',
    items: [{ key: 'dashboard', name: 'Dashboard', icon: 'Home.svg', allowAccess: true }],
  },
  {
    key: 'content',
    name: 'Conteúdos',
    icon: 'Document.svg',
    items: [
      {
        key: 'doubt-and-article',
        name: 'Dúvidas e artigos',
        icon: 'Document.svg',
      },
      {
        key: 'recipes',
        name: 'Receitas',
        icon: 'Document.svg',
      },
      {
        key: 'product-page',
        name: 'Página de produto',
        icon: 'Document.svg',
      },
      {
        key: 'product-families',
        name: 'Página de família de produtos',
        icon: 'Document.svg',
      },
      {
        key: 'category-page',
        name: 'Página de categoria',
        icon: 'Document.svg',
      },
      {
        key: 'routine-care',
        name: 'Rotinas de cuidado',
        icon: 'Document.svg',
      },
      {
        key: 'surveys',
        name: 'Enquetes',
        icon: 'Document.svg',
      },
      {
        key: 'linktree',
        name: 'Linktree',
        icon: 'Document.svg',
      },
    ],
  },
  {
    key: 'benefits',
    name: 'Benefícios',
    icon: 'Gift2.svg',
    items: [{ key: 'benefits', name: 'Benefícios', icon: 'Gift2.svg' }],
  },
  {
    key: 'banners',
    name: 'Banners promocionais',
    icon: 'Price-List-Dollar.svg',
    items: [
      {
        key: 'promo-banners',
        name: 'Banners promocionais',
        icon: 'Price-List-Dollar.svg',
      },
    ],
  },
  {
    key: 'sac',
    name: 'SAC',
    icon: 'Support.svg',
    items: [{ key: 'sac', name: 'SAC', icon: 'Support.svg' }],
  },
  {
    key: 'services',
    name: 'Serviços',
    icon: 'Installation.svg',
    items: [{ key: 'services', name: 'Serviços', icon: 'Installation.svg' }],
  },
  {
    key: 'product-catalog',
    name: 'Catálogo de produtos',
    icon: 'Fridge-4-Doors.svg',
    items: [
      {
        key: 'menu-levels',
        name: 'Níveis do menu',
        icon: 'Fridge-4-Doors.svg',
      },
      {
        key: 'categories',
        name: 'Categorias',
        icon: 'Fridge-4-Doors.svg',
      },
      {
        key: 'products',
        name: 'Produtos',
        icon: 'Fridge-4-Doors.svg',
      },
      {
        key: 'accessories',
        name: 'Acessórios e Consumíveis',
        icon: 'Fridge-4-Doors.svg',
      },
    ],
  },
  {
    key: 'custom-vision-ai',
    name: 'Custom Vision AI',
    icon: 'Program-Assistant.svg',
    items: [
      {
        key: 'ai-models',
        name: 'Modelos',
        icon: 'Program-Assistant.svg',
      },
      {
        key: 'ai-curation',
        name: 'Curadoria',
        icon: 'Program-Assistant.svg',
      },
    ],
  },
  {
    key: 'media-performance',
    name: 'Mídia e performance',
    icon: 'Triple-Heating-Zone.svg',
    items: [
      {
        key: 'media-management',
        name: 'Gestão de mídia',
        icon: 'Triple-Heating-Zone.svg',
      },
      {
        key: 'technical-performance',
        name: 'Performance técnica',
        icon: 'Triple-Heating-Zone.svg',
      },
    ],
  },
  {
    key: 'manage',
    name: 'Gerenciar usuários',
    icon: 'User.svg',
    items: [
      { key: 'my-account', name: 'Minha conta', icon: 'User.svg', allowAccess: true },
      { key: 'user-and-profile', name: 'Usuários', icon: 'User.svg' },
    ],
  },
]
